export class BaseResponse {
  statusCode: number;
  errorCodes?: Array<number>;
  errorMessage?: string;
}
